import React from 'react';
import loader from "../assets/loader.png";

const Loader = ({ isLoading }) => {
    return (
        <>
            {
                isLoading && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                        <img
                            src={loader}
                            alt="Loader"
                            className="w-16 h-16 animate-spin"
                        />
                        {/* <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-custom-purple border-solid"></div> */}
                    </div>
                )
            }
        </>
    );
};

export default Loader;